/**
 * Mock rows for the Settings → Data Export reports table (design reference).
 */
export const DATA_EXPORT_REPORTS_MOCK = [
  {
    id: "exp-1",
    reportName: "Overview – Sept",
    generated: "Oct 1, 2025",
    format: "JSON",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-2",
    reportName: "Agent Report",
    generated: "Sept 25, 2025",
    format: "PDF",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-3",
    reportName: "Overview – Sept",
    generated: "Sept 28, 2025",
    format: "JSON",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-4",
    reportName: "Agent Report",
    generated: "Sept 25, 2025",
    format: "PDF",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-5",
    reportName: "Chats Analysis",
    generated: "Sept 28, 2025",
    format: "PDF",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-6",
    reportName: "Overview – Sept",
    generated: "Oct 1, 2025",
    format: "PDF",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-7",
    reportName: "Chats Analysis",
    generated: "Sept 25, 2025",
    format: "JSON",
    status: "Completed",
    size: "2.4 MB",
  },
  {
    id: "exp-8",
    reportName: "Chats Analysis",
    generated: "Sept 28, 2025",
    format: "PDF",
    status: "Completed",
    size: "2.4 MB",
  },
];
